import { Action, createReducer, on } from '@ngrx/store';
import { ILegalEntitiesBusinessesResponse } from '../../todos/models/businesses.model';
import * as actions from '../actions';

export const getBusinessesFeatureKey = 'getBusinesses';

export interface GetBusinessesState {
  loadLegalEntitiesBusinessesRequest: string;
  loadLegalEntitiesBusinessesResponse: ILegalEntitiesBusinessesResponse[];
  loadLegalEntitiesBusinessesFailure: Error | any;
}

export const initialState: GetBusinessesState = {
  loadLegalEntitiesBusinessesRequest: undefined,
  loadLegalEntitiesBusinessesResponse: undefined,
  loadLegalEntitiesBusinessesFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBusinesses, (state, action) => ({
    ...state,
    loadLegalEntitiesBusinessesRequest: action.param
  })),
  on(actions.loadBusinessesSuccess, (state, action) => ({
    ...state,
    loadLegalEntitiesBusinessesResponse: action.response
  })),
  on(actions.loadBusinessesFailure, (state, action) => ({
    ...state,
    loadLegalEntitiesBusinessesFailure: action.error
  }))
);

export const getLegalEntitiesBusinesses = (state: GetBusinessesState) => {
  return state.loadLegalEntitiesBusinessesResponse;
};
